import { render, staticRenderFns } from "./service-dialog.vue?vue&type=template&id=25996d3c&"
import script from "./service-dialog.vue?vue&type=script&lang=js&"
export * from "./service-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports